import Lang from "@vendors-fr/messages";
import 'jquery-confirm';
import QRCode from 'qrcode'
import {GlobalComponentHelper} from '@plugins-fr/globalProduct';
import {AlertMessage} from '@plugins-fr/alertMessage';
import {addToCartModal, showRegisterPhone} from '@plugins-fr/script';
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {featureMemberQrcode} from "@commons-fr/userStatus";
import {PushAds} from "@commons-fr/pushAds";
import {renderLoginMessage, UserStatusService} from "@commons-fr/userStatusService";
import {loginAction} from "@commons-fr/loginAction";
import {redirectFlash} from "@commons-fr/redirectFlash";
import {recordUserEventTrack} from "@commons/userTracks/userTrack";
import {memberWishListPageDelete} from "@commons/userTracks/eventActionName";

$(function() {
    let memberData = null;
    const JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);

    const uss = new UserStatusService();
    uss.registerFeature(featureMemberQrcode, {}, function(response){
        initMember(response);
    });
    uss.setCallback(function(result){
        (new PushAds()).start();
    });

    if (typeof shops !== 'undefined') {
        const JS_VARS = JSON.parse(shops);

        if (JS_VARS.isMemberIndexBlade) {
            redirectFlash.login = function (response) {
                if (!response.loginResult) {
                    return;
                }

                if (loginAction.getAction() === 'memberIndexWithPosLogin' && $('.js_show_register_phone').length > 0) {
                    showRegisterPhone().then((result) => {
                        if (result.status) {
                            renderLoginMessage(response.loginResult);
                            if (result.type === 'confirm') {
                                $('.js_show_register_phone').attr('style', 'display: none !important;');
                                $('.js_show_member_barcode').attr('style', 'display: block;');
                            }
                        }
                    });
                }
            }
        }

        if (typeof JS_VARS.alertMessage !== 'undefined' && JS_VARS.alertMessage !== '') {
            new AlertMessage({
                'title': JS_VARS.alertMessage,
            }).handle();
        }
    }

    // 分頁功能
    if ($('.js_pagination_area').length > 0) {
        let jsVar = JSON.parse(shops);
        GlobalComponentHelper.bindProductComponent(jsVar);
    }

    // 不顯示麵包屑
    $('.breadcrumb_area').addClass('d-none').removeClass('visible-lg');

    // 獨享好禮
    $('.js_gifts_open_detail').on('click', function(){
        let i = $(this).data('txt');
        $('.js_gift_box').addClass('active');
        $('.js_gift_head').hide();
        $('.js_gifts_detail[data-txt=' + i + ']').removeClass('d-none');
    });

    $('.js_back_gifts').on('click', function(){
        $('.js_gift_box').removeClass('active');
        $('.js_gift_head').show();
        $('.js_gifts_detail').addClass('d-none');
    });


    // 現金積點
    $(".js_open_list").on("click", function(){
        let i = $(this).attr("data-list");
        if( $(".js_opened_list[data-list=" + i + "] ").is(":hidden") ) {
            $(this).find(".icon-plus").attr("class", "icon-minus");
            // $(".js_opened_list[data-list=" + i + "]").removeClass("hide").hide().fadeIn();
            $(".js_opened_list[data-list=" + i + "]").removeClass("d-none");
            if( $("html, body").width() <= 991 ){
                $(".js_opened_transport[data-list=" + i + "]").removeClass("hidden-sm hidden-xs").hide().fadeIn();
            }
        } else {
            $(this).find(".icon-minus").attr("class", "icon-plus");
            $(".js_opened_list[data-list=" + i + "]").addClass("d-none");
            $(".js_opened_transport[data-list=" + i + "]").addClass("hidden-sm hidden-xs").show();
            if( $("html, body").width() <= 991 ){
                $(".js_opened_transport[data-list=" + i + "]").fadeOut();
            }
        }
    });

    // 訂單詳細
    $('.js_order_detail_query').click(function(e) {
        e.stopPropagation();
        e.preventDefault();
        const form = $('#orderquery');
        let order_no = $(this).data('no');
        form.find('input[name="order_no"]').val(order_no);
        form.submit();
    });

    // 現金積點清單 & 活動積分清單
    function PointsList(type) {
        const titleE = $('.js_list_title');
        const nopeClass = 'js_nope';
        const tabE = $('.js_list_tab[data-type='+type+']');
        const listE = $('.js_list_area[data-type='+type+']');
        this.show = function () {
            tabE.addClass('active');
            listE.removeClass('d-none');
            listE.hasClass(nopeClass) ? titleE.addClass('d-none') : titleE.removeClass('d-none');
        };
        this.hide = function () {
            tabE.removeClass('active');
            listE.addClass('d-none');
        };
    }

    const pointsList = {
        $type: '',
        $lists: {},
        $tabClass: '.js_list_tab',
        setType: function (type) {
            if (type !== this.$type) {
                this.$type = type;
                return true;
            }
            return false;
        },
        show: function () {
            let self = this;
            $.each(this.$lists, function(type) {
                self.$type === type ? self.$lists[type].show() : self.$lists[type].hide();
            });
        },
        initListsAndType: function () {
            let self = this;
            $.each($(this.$tabClass), function (_, value) {
                let type = $(value).data('type');
                // init lists
                self.$lists[type] = new PointsList(type);
                // init type
                if ($(value).hasClass('active')) {
                    self.setType(type);
                }
            });
        },
        initClick: function () {
            let self = this;
            $(document).on('click', this.$tabClass, function () {
                let type = $(this).data('type');
                if (self.setType(type)) {
                    self.show();
                }
            });
        },
        init: function () {
            this.initClick();
            this.initListsAndType();
            this.show();
        }
    };

    pointsList.init();

    $(document).on("click", ".js_after_sales", function(){
        let type = $(this).data('value');

        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: '/cart/aftersalesajax',
            data:{type:type},
            success: function(result){
                $.confirm({
                    template: JconfirmTemplateHelper.getTemplate({
                        'templateType': '01',
                        'theme': 'el_confirm el_popup_shopping_info'
                    }),
                    columnClass: 'col-md-10',
                    closeIcon: false,
                    icon: '',
                    title: false,
                    backgroundDismiss: true,
                    draggable: false,
                    offsetTop: 0,
                    offsetBottom: 0,
                    buttons: {
                        cancelButton: {
                            keys: ['esc'],
                            text: '<span class="el_text_inner">'+ Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                            btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                        }
                    },
                    onOpenBefore: function(){
                        this.setContent('<header class="title_area mt-0"><hgroup class="title_content d-flex justify-content-between align-items-center"><h4 class="main_title">' + Lang.get('frontend.member.points.rules') + '</h4></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout">'+result.rules+'</article>')
                        this.$_cancelButton.attr('style', JS_VARS_THEME_STYLE.subButtonStyle);
                        this.$_cancelButton.data('style', JS_VARS_THEME_STYLE.subButtonStyle);
                        this.$_cancelButton.data('hover-style', JS_VARS_THEME_STYLE.subButtonHoverStyle);

                        this.$_cancelButton.hover(
                            function () {
                                $(this).attr('style', $(this).data('hover-style'));
                            },
                            function () {
                                $(this).attr('style', $(this).data('style'));
                            }
                        );
                    }
                });
            }
        });
    });

    // 喜愛商品
    $('.js_wishlist_buy').click(function(e) {
        let item = $(this).parents('.js_wishlist_item');
        let products_id = item.data('pid');
        addToCartModal.onClick(products_id);
    });
    $('.js_wishlist_del').click(function(e) {
        let item = $(this).parents('.js_wishlist_item');
        removeWishlist(item);
    });
    // 喜愛商品 形象網站導入聯絡我們
    $('.js_wishlist_contact').click(function(e) {
        location.href = locale + '/contact';
    });
    const removeWishlist = function (item) {
        let products_id = item.data('pid');
        let type = 'remove';
        const memberWishListAjaxUrl = '/member/wishlist';
        $.ajax({
            url: memberWishListAjaxUrl,
            dataType: 'JSON',
            method: 'POST',
            data: 'products_id=' + products_id + '&type=' + type
        }).done(function (r) {
            recordUserEventTrack(memberWishListPageDelete, memberWishListAjaxUrl, {
                'product_id': Number(products_id),
            });
            if (r.result === true && r.status === 'not_in') {
                item.remove();
            }
            if ($('.js_wishlist_item').length === 0) {
                $('.js_wishlist_area').remove();
                $('.js_wishlist_none').removeClass('d-none');
                $('.js_wishlist_tit').addClass('d-none');
            }
        });
    };



    $('.js_member_area').on("click", ".js_member_info_pop", function(){
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: levelDescriptionUrl,
            success: function(result){
                $.confirm({
                    template: JconfirmTemplateHelper.getTemplate({
                        'templateType': '01',
                        'theme': 'el_confirm el_popup_shopping_info'
                    }),
                    columnClass: 'col-md-10',
                    closeIcon: false,
                    icon: '',
                    title: false,
                    backgroundDismiss: true,
                    draggable: false,
                    offsetTop: 0,
                    offsetBottom: 0,
                    buttons: {
                        cancelButton: {
                            keys: ['esc'],
                            text: '<span class="el_text_inner">'+ Lang.get('frontend.cart.after_sales_service.btn.success') + '</span>',
                            btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                        },
                    },
                    onOpenBefore: function(){
                        this.setContent('<header class="title_area mt-0"><hgroup class="title_content d-flex justify-content-between align-items-center"><h4 class="main_title">' + Lang.get('frontend.guide.title.memberlevel') + '</h4></hgroup><hr class="main_hr"></header><article class="el_popup_content inner_layout">'+result+'</article>');
                        this.$_cancelButton.attr('style', JS_VARS_THEME_STYLE.subButtonStyle);
                        this.$_cancelButton.data('style', JS_VARS_THEME_STYLE.subButtonStyle);
                        this.$_cancelButton.data('hover-style', JS_VARS_THEME_STYLE.subButtonHoverStyle);

                        this.$_cancelButton.hover(
                            function () {
                                $(this).attr('style', $(this).data('hover-style'));
                            },
                            function () {
                                $(this).attr('style', $(this).data('style'));
                            }
                        );
                    }
                });

            }
        });

    });

    // 顯示 mr.pos 會員條碼
    function showMemberBarcode (memberData) {
        const JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_qrcode'
            }),
            columnClass: 'p-0',
            closeIcon: false,
            icon: false,
            title: false,
            keyboardEnabled: true,
            backgroundDismiss: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'btn_cancel btn el_btn md solid el_text m-0 w-100 h-100',
                }
            },
            onOpenBefore: function () {
                this.setContent('<div class="d-flex flex-column justify-content-center vh-100">' +
                    '<div class="d-flex flex-column">' +
                    '<div class="member_qrcode_popup">' +
                    '<div class="member_qrcode d-flex flex-column">' +
                    '<svg id="member_qrcode_svg"></svg>' +
                    '<div class="member_qrcode_num text-center mt-5">' + Lang.get('frontend.footer.memberQrCode') + ' ' + '<b>' + memberData.no_with_space + '</b>' + '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="member_qrcode_tips text-center p-10">' + Lang.get('frontend.member.profile.qrcode.txt') + '</div>' +
                    '</div>');
                const svg = this.$content.find('#member_qrcode_svg');
                svg.JsBarcode(memberData.no, {
                    width: 1,
                    height: 40,
                    margin: 0,
                    displayValue: false
                });
                svg.css('display', 'block').css('margin', 'auto');
                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);
            }
        });
    };

    // 顯示 pos 會員QRcode
     function showMemberQRcode (memberData) {
        const JS_VARS_THEME_STYLE = JSON.parse(themeButtonStyle);
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm el_popup_qrcode'
            }),
            columnClass: 'p-0',
            closeIcon: false,
            icon: false,
            title: false,
            keyboardEnabled: true,
            backgroundDismiss: false,
            offsetTop: 0,
            offsetBottom: 0,
            buttons: {
                cancelButton: {
                    keys: ['esc'],
                    text: '<span class="el_text_inner">' + Lang.get('frontend.other.btn.close') + '</span>',
                    btnClass: 'btn_cancel btn el_btn md solid el_text m-0 w-100 h-100',
                }
            },
            onOpenBefore: function () {
                this.setContent('<div class="d-flex flex-column justify-content-center vh-100">' +
                    '<div class="d-flex flex-column">' +
                    '<div class="member_qrcode_popup">' +
                    '<div class="member_qrcode d-flex flex-column">' +
                    '<canvas id="member_qrcode_canvas"></canvas>' +
                    '<div class="member_qrcode_num text-center mt-5">' + Lang.get('frontend.footer.memberQrCode') + ' ' + '<b>' + memberData.no_with_space + '</b>' + '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="member_qrcode_tips text-center p-10">' + Lang.get('frontend.member.profile.qrcode.txt') + '</div>' +
                    '</div>');

                QRCode.toCanvas(document.getElementById('member_qrcode_canvas'), memberData.no, {
                    width: 200,
                    margin: 0,
                }, function (error) {
                    if (error) console.error(error)
                })
                $("#member_qrcode_canvas").css({"margin":"0 auto"});
                this.$el.find('.btn_cancel').attr('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', JS_VARS_THEME_STYLE.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', JS_VARS_THEME_STYLE.cancelButtonHoverStyle);
            }
        });
    };

    // 顯示 pos 會員條碼
    $('.js_show_member_barcode').click(function (e) {
        e.preventDefault();
        let barcodeType = $(this).data('barcode-type');
        if (barcodeType === 'qrcode') {
            showMemberQRcode(memberData);
        } else {
            showMemberBarcode(memberData)
        }
    });

    const initMemberBarCode = function (memberNo) {
        // 顯示 mr.pos 會員條碼
        const pos_member_barcode_svg = $('#js_member_barcode_svg');
        if (pos_member_barcode_svg.length) {
            pos_member_barcode_svg.JsBarcode(memberNo, {
                // format: "pharmacode",
                // lineColor: "#0aa",
                width: 1.2,
                height: 40,
                margin: 0,
                displayValue: false
            });
        }
    }

    const initMemberQrCode = function (memberNo) {
        // 顯示 pos 會員條碼
        const pos_member_qrcode = $('#js_member_qrcode');
        if (pos_member_qrcode.length) {
            QRCode.toCanvas(document.getElementById('js_member_qrcode'), memberNo, {
                width: 200,
                margin: 0
            }, function (error) {
                if (error) console.error(error)
            })
        }
    }

    const initMember = function (member) {
        if (!member) {
            return false;
        }

        memberData = member;
        initMemberBarCode(memberData.no);
        initMemberQrCode(memberData.no);
    }

});


